<template>
  <div class="transfers-view mt-4">
    <div class="row g-4">
      <div class="col-lg-7 col-md-12">
        <div class="card border-0 shadow-sm transfer-card h-100">
          <div class="card-body">
            <div class="section-heading mb-3">
              <h6 class="mb-1">Notificaciones de transferencias</h6>
              <p class="text-sm text-muted mb-0">Consulta las alertas creadas y abre una vista previa rápida de cada una.</p>
            </div>

            <div class="table-responsive">
              <table class="table table-sm align-items-center transfer-table mb-0">
                <thead>
                <tr>
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Título</th>
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Descripción</th>
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Ícono</th>
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Tipo</th>
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Porcentaje</th>
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Vista previa</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, key) in arrayNotifications" :key="key">
                  <td>
                    <p class="text-sm font-weight-bold mb-0">{{item.title}}</p>
                  </td>
                  <td>
                    <p class="text-xs text-secondary mb-0 description-cell">{{item.description}}</p>
                  </td>
                  <td>
                    <span class="status-badge" :class="iconBadgeClass(item.icon)">{{ iconLabel(item.icon) }}</span>
                  </td>
                  <td>
                    <span class="type-badge">{{ typeLabel(item.type) }}</span>
                  </td>
                  <td>
                    <span class="text-sm font-weight-bold">{{ item.percentage || 0 }}%</span>
                  </td>
                  <td>
                    <button class="btn btn-outline-primary btn-sm mb-0" @click="showNotification(item)">Ver</button>
                  </td>
                </tr>
                <tr v-if="arrayNotifications.length === 0">
                  <td colspan="6" class="text-center py-4 text-muted">Aún no hay notificaciones de transferencias creadas.</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-5 col-md-12">
        <div class="card border-0 shadow-sm transfer-card">
          <div class="card-body">
            <ul class="nav nav-pills transfer-tabs mb-4" role="tablist">
              <li class="nav-item flex-fill" role="presentation">
                <button
                  type="button"
                  class="nav-link w-100"
                  :class="{ active: activeTab === 'simple' }"
                  @click="activeTab = 'simple'"
                >
                  Alerta simple
                </button>
              </li>
              <li class="nav-item flex-fill" role="presentation">
                <button
                  type="button"
                  class="nav-link w-100"
                  :class="{ active: activeTab === 'progress' }"
                  @click="activeTab = 'progress'"
                >
                  Alerta con progreso
                </button>
              </li>
            </ul>

            <div v-show="activeTab === 'simple'">
              <div class="section-heading mb-3">
                <h6 class="mb-1">Crear alerta simple</h6>
                <p class="text-sm text-muted mb-0">Usa esta opción para generar una notificación rápida con ícono.</p>
              </div>

              <div class="mb-3">
                <label class="form-label fw-bold">Título</label>
                <input type="text" class="form-control" v-model="notification.title">
              </div>

              <div class="mb-3">
                <label class="form-label fw-bold">Descripción</label>
                <input type="text" class="form-control" v-model="notification.description">
              </div>

              <div class="mb-3">
                <label class="form-label fw-bold">Ícono</label>
                <select class="form-control" name="icon_type" id="icon_type" v-model="notification.icon">
                  <option value="success">Éxito</option>
                  <option value="info">Información</option>
                  <option value="danger">Error</option>
                </select>
              </div>

              <button class="btn bg-gradient-success w-100 mb-0" @click="createNotifications">Crear notificación simple</button>
            </div>

            <div v-show="activeTab === 'progress'">
              <div class="section-heading mb-3">
                <h6 class="mb-1">Crear alerta con progreso</h6>
                <p class="text-sm text-muted mb-0">Asociala a una cuenta y mostrala con monto y porcentaje.</p>
              </div>

              <div class="mb-3">
                <label class="form-label fw-bold">Título</label>
                <input type="text" class="form-control" v-model="notification_bar.title">
              </div>

              <div class="mb-3">
                <label class="form-label fw-bold">Descripción</label>
                <input type="text" class="form-control" v-model="notification_bar.description">
              </div>

              <div class="mb-3">
                <label class="form-label fw-bold">Cuenta</label>
                <select class="form-control" name="icon_type" id="icon_type" v-model="notification_bar.account_id">
                  <option value="">Selecciona una cuenta</option>
                  <option :value="item._id" v-for="(item, key) in arrayAccounts" :key="key">{{item.bank}}</option>
                </select>
              </div>

              <div class="row g-3">
                <div class="col-md-6">
                  <label class="form-label fw-bold">Monto</label>
                  <input type="text" class="form-control" v-model="notification_bar.amount">
                </div>
                <div class="col-md-6">
                  <label class="form-label fw-bold">Porcentaje</label>
                  <input type="text" class="form-control" v-model="notification_bar.percentage">
                </div>
              </div>

              <button class="btn bg-gradient-info w-100 mt-4 mb-0" @click="createBarNotifications">Crear notificación con progreso</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {get, post} from "@/utils/httpRequest";

export default {
  name: "Notifications",
  data: () => ({
    user_id: null,
    activeTab: 'simple',
    arrayNotifications: [],
    arrayAccounts: [],
    notification: {
      title: '',
      description: '',
      icon: '',
      type: 'alert',
    },
    notification_bar: {
      title: '',
      description: '',
      amount: 0,
      percentage: 0,
      account_id: '',
      type: 'progress',
    }
  }),
  mounted() {
    this.user_id = this.$route.query.id
    this.getNotifications();
    this.getAccounts();
  },
  methods:{
    iconLabel(icon){
      const labels = {
        success: 'Éxito',
        info: 'Info',
        danger: 'Error',
      }
      return labels[icon] || icon
    },
    iconBadgeClass(icon){
      return {
        'badge-success': icon === 'success',
        'badge-info': icon === 'info',
        'badge-danger': icon === 'danger',
      }
    },
    typeLabel(type){
      return type === 'progress' ? 'Progreso' : 'Alerta'
    },
    async getAccounts(){
      const {data} = await get(`bank-accounts/get-all-by-user?id=${this.user_id}`)
      this.arrayAccounts = data
    },
    async getNotifications(){
        const {data} = await get(`transfer-notifications/all-by-user?id=${this.user_id}`)
      this.arrayNotifications = data
    },
    async createNotifications(){
      if(this.notification.title !== '' && this.notification.description !== ''){
        await post("transfer-notifications/create",{...this.notification, user: this.user_id})
        this.notification.title = ''
        this.notification.description = ''
        await this.getNotifications()
        this.$swal({
          html: 'Procesado con éxito',
          icon: 'success',
          timer: 2000,
          showCancelButton: false,
          showConfirmButton: false,
        });
      }
    },
    async createBarNotifications(){
      if(this.notification_bar.title !== '' && this.notification_bar.description !== '' && this.notification_bar.percentage> 0){
        await post("transfer-notifications/create-bar",{...this.notification_bar, user: this.user_id})
       this.notification_bar = {
         title: '',
         description: '',
         amount: 0,
         percentage: 0,
         account_id: '',
         type: 'progress',
       }
        await this.getNotifications()
        this.$swal({
          html: 'Procesado con éxito',
          icon: 'success',
          timer: 2000,
          showCancelButton: false,
          showConfirmButton: false,
        });
      }
    },
    async showNotification(item){
      this.$swal({
        title: item.title,
        html: item.description,
        icon: item.icon,
        timer: 2000,
        showCancelButton: false,
        showConfirmButton: false,
      });
    }
  }
}
</script>

<style scoped>
.transfer-card {
  border-radius: 1rem;
}

.section-heading h6 {
  font-size: 1rem;
  font-weight: 700;
}

.transfer-tabs {
  background: #f1f5f9;
  border-radius: 999px;
  padding: 0.25rem;
  gap: 0.25rem;
}

.transfer-tabs .nav-link {
  border-radius: 999px;
  color: #67748e;
  font-weight: 600;
  font-size: 0.8rem;
  padding: 0.5rem 0.75rem;
  transition: all 0.15s ease;
}

.transfer-tabs .nav-link.active {
  background: #fff;
  color: #344767;
  box-shadow: 0 2px 6px rgba(20, 20, 43, 0.08);
}

.transfer-table thead th {
  border-bottom: 1px solid #e9ecef;
  padding-bottom: 0.85rem;
}

.transfer-table tbody td {
  vertical-align: middle;
  padding-top: 1rem;
  padding-bottom: 1rem;
  border-color: #edf2f7;
}

.description-cell {
  max-width: 240px;
  white-space: normal;
}

.status-badge,
.type-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.35rem 0.75rem;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 700;
}

.badge-success {
  background: rgba(130, 214, 22, 0.15);
  color: #4f8a10;
}

.badge-info {
  background: rgba(23, 193, 232, 0.15);
  color: #0b6e99;
}

.badge-danger {
  background: rgba(234, 6, 6, 0.12);
  color: #c1121f;
}

.type-badge {
  background: #f1f5f9;
  color: #344767;
}

</style>
